<div class="page">
  <div class="container">
    <ng-content></ng-content>
  </div>
</div>
